module.exports = __webpack_public_path__ + "img/antes_despues_324.b1073543.png";